var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.spaces),function(space){return _c('div',{key:space},[_c('DocumentDisplaySection',{attrs:{"space":space}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }